"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _PulseConfig = _interopRequireDefault(require("../util/PulseConfig"));

var _store = _interopRequireDefault(require("../store/store"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var NotificationSelectors = _interopRequireWildcard(require("../store/reducers/NotificationReducer"));

var AnnouncementSelectors = _interopRequireWildcard(require("../store/reducers/AnnouncementReducer"));

/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
var PulseApiHelper = {
  /**
   * Get ANS Api Host Url.
   *
   * @returns {string} ANS Host Url.
   */
  getHostUrl: function getHostUrl() {
    return (0, _PulseConfig.default)('ANS_HOST');
  },
  getLongPollHostUrl: function getLongPollHostUrl() {
    return (0, _PulseConfig.default)('ANS_LONG_POLL_HOST');
  },
  getSKMSHostUrl: function getSKMSHostUrl() {
    return (0, _PulseConfig.default)('SKMS_HOST');
  },
  getAdobeStatusHostUrl: function getAdobeStatusHostUrl() {
    return (0, _PulseConfig.default)('ADOBE_STATUS_HOST');
  },
  getCurrentHostUrl: function getCurrentHostUrl() {
    return (0, _PulseConfig.default)('CURRENT_ENVIRONMENT_HOST');
  },

  /**
   * Get User's current locale query parameter string.
   *
   * @returns {string} Locale query param.
   */
  getUserLocale: function getUserLocale() {
    return NotificationSelectors.getLocale(_store.default.getState());
  },

  /**
   * Get Default Headers for ANS APIs.
   *
   * @param {boolean} setContentType Whether "Content-Type=application/json" header needs to be set.
   * @returns {Object} Default Headers.
   */
  getDefaultHeaders: function getDefaultHeaders() {
    var setContentType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var headers = {
      Accept: 'application/json',
      Authorization: "Bearer ".concat(NotificationSelectors.getAccessToken(_store.default.getState())),
      'x-adobe-app-id': (0, _PulseConfig.default)('ANS_APP_ID'),
      'x-api-key': (0, _PulseConfig.default)('ADOBE_IO_API_KEY'),
      'x-org-id': NotificationSelectors.getActiveIMSOrg(_store.default.getState())
    };

    if (setContentType) {
      headers['Content-Type'] = 'application/json';
    }

    return headers;
  },

  /**
   * Convert a Notification object from ANS format to Pulse format
   * {
   *   "notification-id": "b94120ec-9814-458c-b0c1-16b03f4a15c2",
   *   "user-id": "B697B571576257F07F000101@AdobeID",
   *   "type": "exc.approval",
   *   "sub-type": "exc.approval.activity",
   *   "app-id": [
   *       "ExcPulse"
   *   ],
   *   "state": "NEW",
   *   "timestamp": 1543502160541,
   *   "created-timestamp": 1543502160541,
   *   "payload": "Stil waiting for Half-Life 3",
   *   "metadata": {
   *       "product": "ExC App",
   *       "groupingId": "grp",
   *       "updateText": "update text",
   *       "priority": "high",
   *       "actions": "[{\"action\" : \"approve\", \"endpoint\": \"approve-endpoint\", \"state\": \"enabled\"}, {\"action\" : \"reject\", \"endpoint\": \"reject-endpoint\", \"state\": \"enabled\"}]",
   *       "url": "https://www.google.co.in"
   *   },
   *   "delivery-type": "UNICAST",
   *   "muted": false,
   *   "sort-timestamp": 1543502160541
   * }
   * @param {object} ansNotificationObject ANS Notification Data Json Object
   * @returns {PulseMessageObject} corresponding Pulse Notification Data Object
   *
   *
   *
   *
   *
   *
   *
   *
   *
   *
   */
  createPulseMessageObject: function createPulseMessageObject(ansNotificationObject) {
    var payload = undefined;

    try {
      payload = JSON.parse(ansNotificationObject.payload);
    } catch (e) {
      return null;
    }

    var pulseMessageObject = {
      id: ansNotificationObject['notification-id'],
      text: payload.message ? payload.message : '',
      url: payload.url ? payload.url : '',
      immediateActions: null,
      isUser: !(0, _isEmpty.default)(payload.user),
      avatar: payload.user && payload.user.avatar ? payload.user.avatar : PulseApiHelper.getAvatarForProduct(ansNotificationObject.metadata && ansNotificationObject.metadata.product),
      type: ansNotificationObject.type,
      firstName: payload.user && payload.user.firstName ? payload.user.firstName : '',
      lastName: payload.user && payload.user.lastName ? payload.user.lastName : '',
      subtype: ansNotificationObject['sub-type'],
      snoozeDisabled: false,
      priority: 'low',
      product: 'Experience Cloud',
      createdTimestamp: ansNotificationObject['created-timestamp'],
      isRead: ansNotificationObject.state !== 'NEW',
      sortedTimestamp: ansNotificationObject['sort-timestamp']
    };

    if (ansNotificationObject.metadata) {
      var metadata = ansNotificationObject.metadata;
      pulseMessageObject['product'] = metadata.product ? metadata.product : 'Experience Cloud';
      pulseMessageObject['priority'] = metadata.priority ? metadata.priority : 'low';
      pulseMessageObject['updateText'] = metadata.updateText ? metadata.updateText : '';
      pulseMessageObject['isActionable'] = metadata.isActionable ? metadata.isActionable === 'true' : false;
      pulseMessageObject['actions'] = metadata.actions ? metadata.actions : undefined;

      if (metadata.reminderTime) {
        pulseMessageObject['reminderTime'] = parseInt(metadata.reminderTime);
      }
    }

    return pulseMessageObject;
  },

  /**
   * TODO: Need to do strict typing.
   * @param solution
   */
  getAvatarForProduct: function getAvatarForProduct() {
    var solution = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Experience Cloud';

    /**
     * Default solution name would be Experience Cloud
     * This function returns single object of the matching product from the appassembly response
     */
    var appAssemblyPayload = AnnouncementSelectors.getUserEntitlements(_store.default.getState());
    return appAssemblyPayload.find(function (product) {
      return solution.startsWith(product.name);
    });
  },
  createANSFormatForReminders: function createANSFormatForReminders(pulseMessageObject) {
    /**
     * update in place is needed to disallow the sorting order of the timestamp
     */
    var metadata = {
      entry: [{
        'key-name': 'update-in-place',
        'key-value': 'true'
      }, {
        'key-name': 'reminderTime',
        'key-value': String(pulseMessageObject.reminderTime)
      }]
    };
    return {
      'notification-id': pulseMessageObject.id,
      timestamp: pulseMessageObject.reminderTime,
      metadata: metadata
    };
  },
  createANSFormatForClearReminders: function createANSFormatForClearReminders(pulseMessageObject) {
    /**
     * update in place is needed to disallow the sorting order of the timestamp
     */
    var metadata = {
      entry: [{
        'key-name': 'update-in-place',
        'key-value': 'true'
      }, {
        'key-name': 'reminderTime',
        'key-value': ''
      }]
    };
    return {
      'notification-id': pulseMessageObject.id,
      metadata: metadata
    };
  },
  createANSResponseObject: function createANSResponseObject(pulseMessageObject) {
    //as of now, the only thing that could client change is the read status
    //so only updating that should be enough
    return {
      'notification-id': pulseMessageObject.id,
      state: pulseMessageObject.isRead ? 'READ' : 'NEW'
    };
  }
};
var _default = PulseApiHelper;
exports.default = _default;